import {
  FETCH_ALL_EXPERIMENTS,
  FETCH_EXPERIMENT_SUMMARY,
} from '../constants/ActionTypes';

const INITIAL_STATE = { experiments: null, summary: null };

export default function experimentsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_ALL_EXPERIMENTS:
      return { ...state, experiments: [...(action.payload || [])] };
    case FETCH_EXPERIMENT_SUMMARY:
      return { ...state, summary: action.payload };
    default:
      return state;
  }
}
